export function getCloudApiUrl() {
  const configured = (process.env.VUE_APP_OPENSHOT_API_URL || '').trim()
  if (configured) {
    return configured.replace(/\/+$/, '')
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin
  }
  return ''
}
